import { useMemo } from 'react';
import { useAccountsQuery } from '@vrplatform/data';

export function useTaxRateAccountAssignmentQuery() {
  const queryData = useAccountsQuery();

  const data = useMemo(() => {
    if (!queryData.data) {
      return undefined;
    }

    const account = queryData.data.find(
      (item) =>
        item.status === 'active' &&
        item.assignments.includes('expense_salesTax')
    );

    return account
      ? {
          id: account.id,
          title: account.name,
        }
      : null;
  }, [queryData.data]);

  return {
    ...queryData,
    data,
  };
}
